import React, { type ReactNode } from "react";

/**
 * Recursively extracts text content from a React element tree
 * so it can be passed to AccessibilityInfo.announceForAccessibility.
 * It is required to have a string rather than a React element.
 */
export const extractText = (node: ReactNode): string => {
  if (typeof node === "string") return node;
  if (typeof node === "number") return String(node);
  if (!node) return "";
  if (Array.isArray(node)) return node.map(extractText).join("");
  if (React.isValidElement(node)) {
    // eslint-disable-next-line @typescript-eslint/consistent-type-assertions -- RN-5783 baseline: pre-existing cast; migrate to zod/proper types (see docs/type-assertions.md)
    return extractText((node.props as { children?: ReactNode }).children);
  }
  return "";
};
